"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genAppInfo = genAppInfo;
exports.checkAppVersion = checkAppVersion;

var _regex = require("../regex");

function genAppInfo(protocal, ua, options) {
  var _clientUAParams, _clientUAParams$Type, _clientUAParams2, _clientUAParams2$Lang, _clientUAParams2$Lang2, _options$defaultLangu, _clientUAParams3, _clientUAParams3$Ship, _options$defaultCount, _clientUAParams4, _clientUAParams4$Curr, _options$defaultCurre;

  var result = _regex.userAgentRegExp.exec(ua);

  var clientUAParams = {};

  if (result !== null) {
    clientUAParams = result[1].split(";").reduce(function (pValue, cValue) {
      var arrs = cValue.split("/");

      if (arrs.length > 1) {
        pValue[arrs[0]] = arrs.slice(1).join("");
      }

      return pValue;
    }, {});
  }

  return {
    protocal: protocal,
    ua: ua,
    options: options,
    clientUAParams: clientUAParams,
    isInApp: ((_clientUAParams = clientUAParams) === null || _clientUAParams === void 0 ? void 0 : (_clientUAParams$Type = _clientUAParams.Type) === null || _clientUAParams$Type === void 0 ? void 0 : _clientUAParams$Type.toLowerCase()) === (protocal === null || protocal === void 0 ? void 0 : protocal.toLowerCase()),
    language: ((_clientUAParams2 = clientUAParams) === null || _clientUAParams2 === void 0 ? void 0 : (_clientUAParams2$Lang = _clientUAParams2.Language) === null || _clientUAParams2$Lang === void 0 ? void 0 : (_clientUAParams2$Lang2 = _clientUAParams2$Lang.replace(/-hans$/i, "")) === null || _clientUAParams2$Lang2 === void 0 ? void 0 : _clientUAParams2$Lang2.toLowerCase()) || (options === null || options === void 0 ? void 0 : (_options$defaultLangu = options.defaultLanguage) === null || _options$defaultLangu === void 0 ? void 0 : _options$defaultLangu.toLowerCase()) || "en",
    country: ((_clientUAParams3 = clientUAParams) === null || _clientUAParams3 === void 0 ? void 0 : (_clientUAParams3$Ship = _clientUAParams3.ShipTo) === null || _clientUAParams3$Ship === void 0 ? void 0 : _clientUAParams3$Ship.toUpperCase()) || (options === null || options === void 0 ? void 0 : (_options$defaultCount = options.defaultCountry) === null || _options$defaultCount === void 0 ? void 0 : _options$defaultCount.toUpperCase()),
    currency: ((_clientUAParams4 = clientUAParams) === null || _clientUAParams4 === void 0 ? void 0 : (_clientUAParams4$Curr = _clientUAParams4.Currency) === null || _clientUAParams4$Curr === void 0 ? void 0 : _clientUAParams4$Curr.toUpperCase()) || (options === null || options === void 0 ? void 0 : (_options$defaultCurre = options.defaultCurrency) === null || _options$defaultCurre === void 0 ? void 0 : _options$defaultCurre.toUpperCase())
  };
}

function checkAppVersion(wishVersion, appVersion) {
  if (!appVersion) {
    return false;
  }

  var versionParts = appVersion.split(".");

  if (versionParts.length === 1) {
    return parseInt(appVersion, 10) >= wishVersion;
  }

  var numberStr = "".concat(versionParts[0], ".").concat(versionParts.slice(1).join(""), ";"); // wish version must be x.xx

  return parseFloat(numberStr) >= wishVersion;
}